
import react from "react";
import sanga3 from "../../assets/gedo (8).jpg";
import gedo from "../../assets/gedo (9).jpg"
import gedo3 from "../../assets/civil.jpg"
import gedo4 from "../../assets/civil2.webp"
import gedo5 from "../../assets/civil3.jpg"
import gedo2 from "../../assets/offshore.mp4"
import { useState, useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css'

import axios from 'axios';

import { API_URL } from "../../config";

function OffshoreWork() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const images = [sanga3, gedo3, gedo4, gedo5, gedo4, sanga3]
  const [preview, setPreview] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    location: "",
    phone: "",
    date: "",
    passport: null,
    supplyLitter: "",
    email: "",
    IMO: "",
    services: [],
  });

  const handleCheckbox = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setFormData({
        ...formData, services:
          [...formData.services, value]
      });
    } else {
      setFormData({
        ...formData, services:
          formData.services.filter((s) => s !== value)
      });
    }

  }

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "passport" && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.companyName.trim() || !formData.location.trim() || !formData.supplyLitter.trim() || !formData.phone.trim()
      || !formData.date.trim() || !formData.passport || !formData.email.trim() || !formData.IMO.trim() || !formData.services.join().trim()) {
      alert("فضلاً املئي املاء كل الحقول");
      return;
    }

    const data = {
      name: formData.name,
      companyName: formData.companyName,
      location: formData.location,
      phone: formData.phone,
      date: formData.date,
      passport: formData.passport?.name || "uploaded",
      supplyLitter: formData.supplyLitter,
      email: formData.email,
      IMO: formData.IMO,
      services: formData.services.join(" , ")
    };
    try {
      await axios.post(`${API_URL}/OffshoreWork`, data);
      alert('تم الطلب بنجاح ✅');
      setFormData({ name: "", companyName: "", location: "", phone: "", date: "", passport: null, supplyLitter: "", email: "", IMO: "", services: [] });
      setPreview(null);
    }
    catch (err) {
      console.log(err);
      alert("حدث خطأ: " + (err.response?.data?.error || err.message));
    }
  };

  return (

    <div className="bg-green-30">

      <div className="w-full h-screen  relative">
        <img src={sanga3} className="w-full h-full object-cover  " />
        <div className="absolute inset-0 bg-black/40 flex items-center flex flex-col justify-center">
          <h1 className="text-white  text-2xl md:text-2xl font-bold">Blue Shark</h1>
          <h1 className="text-white  text-5xl md:text-5xl font-bold">Offshore Work </h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className=" mx-w-md mx-auto mt-10 p-4 
  items-center justify-center w-[80%]">
        <div className="space-y-12">
          <div className=" pb-12">
            <h2 data-aos="fade-up" className="text-base/7 font-semibold text-gray-900">Book Now</h2>
            <p data-aos="fade-up" className="mt-1 text-sm/6 text-gray-600">If you want this services please fill this information</p>

            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-3" data-aos="fade-up">

                <label for="first-name" className="block text-sm/6 font-medium text-gray-900">Name</label>
                <div className="mt-2">
                  <input onChange={handleChange} type='text' value={formData.name} id="first-name" name="name" autocomplete="given-name" className="block border w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>

              <div data-aos="fade-up" className="sm:col-span-3">
                <label for="last-name" className="block text-sm/6 font-medium text-gray-900">Company Nmae</label>
                <div className="mt-2">
                  <input onChange={handleChange} id="last-name" type="text" value={formData.companyName} name="companyName" autocomplete="family-name" className="block  border w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>

              <div data-aos="fade-up" className="sm:col-span-3">
                <label for="email" className="block text-sm/6 font-medium text-gray-900">Phone Number</label>
                <div className="mt-2">
                  <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autocomplete="phone" className="block border  w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>

              <div data-aos="fade-up" className="sm:col-span-3">
                <label for="email" className="block text-sm/6 font-medium text-gray-900">IMO Number</label>
                <div className="mt-2">
                  <input onChange={handleChange} type="tex" value={formData.IMO} name="IMO" className="block border  w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>

              <div data-aos="fade-up" className="sm:col-span-3">
                <label for="email" className="block text-sm/6 font-medium text-gray-900">Email</label>
                <div className="mt-2">
                  <input onChange={handleChange} id="email" type="email" value={formData.email} name="email" autocomplete="email" className="block border  w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>

              <div data-aos="fade-up" className="sm:col-span-3">
                <label for="email" className="block text-sm/6 font-medium text-gray-900">Location</label>
                <div className="mt-2">
                  <input onChange={handleChange} id="email" type="text"
                    value={formData.location} name="location" autocomplete="location"
                    className="block border  w-full rounded-md bg-white px-3 py-1.5 text-base 
             text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400
              focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>
              <div data-aos="fade-up" className="sm:col-span-4">
                <label for="date" className="block  text-sm/6 font-medium text-gray-900">Arraive Date </label>
                <div className="mt-2">
                  <input onChange={handleChange} id="date" type="date" value={formData.date} name="date" autocomplete="date" className="block border w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                </div>
              </div>
              <div data-aos="fade-up" className="sm:col-span-4">
                <label for="date" className="block  text-sm/6 font-medium text-gray-900">OffshoreWork Way</label>

                <label >
                  <input type="checkbox" onChange={handleCheckbox} name="SBM" value="SBM /PLEM installation & Maintenance" className="m-3" />
                  SBM / PLEM installation & Maintenance
                </label><br />
                <label >
                  <input type="checkbox" onChange={handleCheckbox} name="Pipe" value="Pipe Laying & Repair" className="m-3" />
                  Pipe Laying & Repair
                </label><br />
                <label>
                  <input type="checkbox" onChange={handleCheckbox} name="Anode" value="Anode Inspection & Replacment" className="m-3" />
                  Repair of Offshore Structure & installation of Fendering System
                </label>


              </div>

              <div data-aos="fade-up" className="sm:col-span-4">
                <label for="email" className="block text3 font-medium text-gray-900">Details Letter</label>
                <div className="mt-2">
                  <textarea onChange={handleChange} id="about" name="supplyLitter"
                    value={formData.supplyLitter} rows="3"
                    className="block border  w-full rounded-md bg-white px-3 py-1.5 text-base 
             text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400
              focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"></textarea>
                </div>
              </div>
              <div data-aos="fade-up" className="sm:col-span-4">
                <div className=" pb-4">
                  <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div className="col-span-full">
                      <label for="cover-photo" className="block text-sm/6 font-medium text-gray-900">ID photo</label>
                      <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
                        <div className="text-center">
                          <svg viewBox="0 0 24 24" fill="currentColor" data-slot="icon" aria-hidden="true" className="mx-auto
               size-12 text-gray-300">
                            <path d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0
                 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75
                  0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06
                   1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0
                    1.125 1.125 0 0 1-2.25 0Z" clip-rule="evenodd" fill-rule="evenodd" />
                          </svg>
                          <div className="mt-4 flex text-sm/6 text-gray-600">
                            <label for="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold
                 text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 
    ]focus-within:outline-hidden hover:text-indigo-500">
                              <span>Upload a file</span>
                              <input type="file" name="passport" onChange={handleChange} accept='image/*' />
                              {preview && (
                                <img
                                  src={preview}
                                  alt="passport preview"
                                  className="mt-4 w-32 h-32 object-cover rounded-md"
                                />
                              )}
                            </label>

                          </div>
                          <p className="text-xs/5 text-gray-600">PNG, JPG, GIF up to 10MB</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div data-aos="fade-up" className="mt-6 flex items-center justify-end gap-x-6">

              <button type="submit" className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-green-600">Send</button>
            </div>
          </div>
        </div>
      </form>

      <div className="relative w-full h-screen flex items-center justify-center " >
        <video data-aos="fade-left" loop controls playsInline
          className="w-[60%] h-[50%] rounded-lg justify-center " >
          <source src={gedo2}></source> </video>

      </div>

      <div className='w-full  my-10  rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>Offshore Work</h1></center>
        <div data-aos="fade-up" className='max-w-6xl mx-auto  grid grid-cols-1 sm:grid-cols-2 md:sm:grid-cols-3 gap-8 '>

          {images.map((image, index) => (
            <img src={image} className=' rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>

    </div>
  );

}
export default OffshoreWork;